import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.389 10.5l2.61 1.5m0 0l2.613-1.5M12 12v2.5m0 2.5v2.814m0 0l-2.567-1.482M12 19.814l2.567-1.482m4.183-2.415L16.308 14.5m2.442 1.417l-2.567 1.482m2.567-1.482v-2.964m-13.5 2.964L7.692 14.5M5.25 15.917l2.567 1.482M5.25 15.917v-2.964M12 7.314V4.5m0 0l2.567 1.482M12 4.5L9.433 5.982M5.25 8.397l2.442 1.417M5.25 8.397v2.964m0-2.964l2.567-1.482M18.75 8.397l-2.442 1.417m2.442-1.417v2.964m0-2.964l-2.567-1.482"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.389 10.5l2.61 1.5m0 0l2.613-1.5M12 12v2.5m0 2.5v2.814m0 0l-2.567-1.482M12 19.814l2.567-1.482m4.183-2.415L16.308 14.5m2.442 1.417l-2.567 1.482m2.567-1.482v-2.964m-13.5 2.964L7.692 14.5M5.25 15.917l2.567 1.482M5.25 15.917v-2.964M12 7.314V4.5m0 0l2.567 1.482M12 4.5L9.433 5.982M5.25 8.397l2.442 1.417M5.25 8.397v2.964m0-2.964l2.567-1.482M18.75 8.397l-2.442 1.417m2.442-1.417v2.964m0-2.964l-2.567-1.482"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.777 21L24 24m0 0l5.224-3M24 24v5m0 5v5.628m0 0l-5.134-2.964M24 39.628l5.134-2.964m8.366-4.83L32.616 29m4.884 2.834l-5.134 2.965m5.134-2.965v-5.927m-27 5.927L15.384 29M10.5 31.834l5.134 2.965M10.5 31.834v-5.927M24 14.629V9.001m0 0l5.134 2.964M24 9l-5.134 2.964m-8.366 4.83l4.884 2.834M10.5 16.795v5.928m0-5.928l5.134-2.964M37.5 16.795l-4.884 2.834m4.884-2.834v5.928m0-5.928l-5.134-2.964"
  }))
};
export var AR = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});